import { createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/store/store'
import { kProcessingPollIntervalMs } from '@/uppy-file-upload/constants'
import { getUserFiles } from '@/uppy-file-upload/fetch/get-user-files'
import { UserFilesPollingActions } from './slice'
import { selectCombinedUserFilePollingIds } from './selectors'

export const userFilesPollingListenerMiddleware = createListenerMiddleware()
const startListener = userFilesPollingListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

startListener({
  actionCreator: UserFilesPollingActions.upsertPollingSource,
  effect: async (_action, listenerApi) => {
    if (listenerApi.getState().userFilesPollingState.isRunning) {
      return
    }

    listenerApi.dispatch(UserFilesPollingActions.processorStarted())
    const runId = listenerApi.getState().userFilesPollingState.runId

    while (true) {
      const state = listenerApi.getState()
      const pollingState = state.userFilesPollingState
      const hasSources = Object.keys(state.userFilesPollingState.sourcesById).length > 0

      if (!pollingState.isRunning || pollingState.runId !== runId) {
        break
      }

      if (!hasSources) {
        listenerApi.dispatch(UserFilesPollingActions.processorStopped())
        break
      }

      const requestedIds = selectCombinedUserFilePollingIds(state)

      if (requestedIds.length > 0) {
        try {
          const response = await getUserFiles(requestedIds, true)

          listenerApi.dispatch(
            UserFilesPollingActions.pollBatchReceived({
              requestedIds,
              files: response.files,
            })
          )
          listenerApi.dispatch(UserFilesPollingActions.pollCompleted())
        } catch (error) {
          console.error('[UserFilesPolling] Error polling file status:', error)
        }
      }

      await listenerApi.delay(kProcessingPollIntervalMs)
    }
  },
})

startListener({
  actionCreator: UserFilesPollingActions.removePollingSource,
  effect: async (_action, listenerApi) => {
    const state = listenerApi.getState()
    const hasSources = Object.keys(state.userFilesPollingState.sourcesById).length > 0

    if (state.userFilesPollingState.isRunning && !hasSources) {
      listenerApi.dispatch(UserFilesPollingActions.processorStopped())
    }
  },
})
